import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Divider } from "@material-ui/core";

import { getConfigItemByParentId } from "store/state/configItems";
import { RECOURSE } from "constants/configItemParents";
import SectionTitle from '../Components/SectionTitle';
import { transformNumber } from "utils/transformNumber";
import GridRadioButtonList from "../Components/GridRadioButtonList";
import TypeAheadDropdown from "../Components/TypeAheadDropdown";
import GridTextInput from "../Components/GridTextInput";
import { yesNoOptions } from "./lists";
import { setConfigItemListState } from "../util";
import GridPercentInput from "../Components/GridPercentInput";


const NON_RECOURSE = "bc1814ab-4683-11e9-82f6-0242ac120002";
class Recourse extends React.Component {
  state = {
    recourseTypes: [],
    recourseAmount: ""
  };

  static getDerivedStateFromProps(props, state) {
    const { loan } = props;
    return {
      recourseAmount:
        loan.recourseAmount || loan.recourseAmount === 0
          ? loan.recourseAmount * 100
          : ""
    };
  }

  componentDidMount() {
    this.props.getConfigItemByParentId({ id: RECOURSE });
  }
  componentDidUpdate = () => {
    if (this.props.configItems && this.props.configItems.configItemByParent) {
      setConfigItemListState(RECOURSE, "recourseTypes", this);
    }
  };
  render() {
    const {
      loan,
      handleChange,
      handleTextChange,
      handleBooleanChange,
      isNewLoan,
      isEditing,
      isInitialized
    } = this.props;

    return (
      <Fragment>
        <span id="loan_recourse">
        <Grid hidden={!isInitialized} item xs={7}>
          <SectionTitle>Recourse</SectionTitle>
        </Grid>
        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="recourseId"
            label="Recourse"
            placeholder="Select a Recourse Type"
            options={this.state.recourseTypes}
            value={loan.recourseId}
            handleChange={data => handleChange("recourseId", data)}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="recourseAmount"
            label="Recourse Amount"
            value={this.state.recourseAmount}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "recourseAmount",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value) / 100
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized && loan.recourseId !== NON_RECOURSE}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridRadioButtonList
            name="burndown"
            label="Burndown"
            value={loan.burndown}
            onChange={handleBooleanChange}
            options={yesNoOptions}
            isEditing={isEditing}
            shouldShow={isInitialized && loan.recourseId !== NON_RECOURSE}
          />{" "}
        </Grid>
        <Grid container item={true} xs={12}>
          <GridTextInput
            name="recourse"
            label="Note"
            value={loan.recourse}
            isEditing={isEditing}
            shouldShow={isInitialized}
            onChange={handleTextChange}
          />{" "}
        </Grid>
        </span>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { loading, configItems } = state;
  return {
    loading,
    configItems
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      getConfigItemByParentId
    }
  )  
)(Recourse);
